import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { environment } from '../config/environment';
import { msalInstance } from '../config/auth';

const isLocalhost = window.location.hostname === 'localhost';

export const msalBaseQuery = fetchBaseQuery({
  baseUrl: environment.apiUrl,
  credentials: isLocalhost ? 'omit' : 'include',

  prepareHeaders: async headers => {
    const accounts = msalInstance.getAllAccounts();

    if (accounts.length > 0) {
      const account = accounts[0];

      try {
        const tokenResponse = await msalInstance.acquireTokenSilent({
          scopes: environment.azure.scopes,
          account
        });

        headers.set('Authorization', `Bearer ${tokenResponse.accessToken}`);
        headers.set('Content-Type', 'application/json');
      } catch (err) {
        // Token refresh failed — trigger redirect login without throwing,
        // so RTK Query does not surface a generic error while redirect is in progress
        const { authService } = await import('../services/auth.service');
        authService.logout();
      }
    }

    return headers;
  }
});

const baseQueryWithNetworkHandler: typeof msalBaseQuery = async (args, api, extraOptions) => {
  const result = await msalBaseQuery(args, api, extraOptions);
  if (result.error) {
    if (result.error.status === 'FETCH_ERROR') {
      window.location.href = window.location.origin;
    }
    if (result.error.status === 401) {
      import('../services/auth.service').then(({ authService }) => {
        authService.logout();
      });
    }
    if (result.error.status === 403) {
      window.location.href = window.location.origin + '/pricing-regional';
    }
  }
  return result;
};

export const baseApi = createApi({
  reducerPath: 'baseApi',
  baseQuery: baseQueryWithNetworkHandler,
  keepUnusedDataFor: 0,
  tagTypes: [
    'BrandOrder',
    'RegionalBrandOrder',
    'Summary',
    'RegionalSummary',
    'ProvinceSummary',
    'ProvinceOverallSummary',
    'ProceComparissonFilters',
    'StationProfile',
    'AzkList',
    'BrandsList',
    'UsersList',
    'SalesExpertsList',
    'SchedulerEntries',
    'PriceProcessingFilters',
    'PriceProcessingData',
    'AzkOkkoStations',
    'AzkCompetitorStations',
    'AzkCompetitorFilters',
    'AzkBindings',
    'AzkFormOptions',
    'OrdersFilters',
    'Orders',
    'OrdersHistory'
  ],
  endpoints: () => ({})
});
